export default __webpack_public_path__ + "static/media/img-step4.ed9fbb76.png";